import styled from "styled-components";

export const TopRightBadgeContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
`;
